"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliceMaskPolicy = exports.ELEMENT_PARAMETERS_SLICE_KEY = exports.PARAMETERS_SLICE_KEY = exports.ELEMENT_SIGMA_MODEL_TYPE_SLICE_KEY = exports.SIGMA_MODEL_TYPE_SLICE_KEY = void 0;
exports.firstSigmaSubModel = firstSigmaSubModel;
exports.readElementSigmaModelType = readElementSigmaModelType;
const sigma_engine_shared_1 = require("@cadstrom/sigma-engine-shared");
const slice_key_1 = require("./slice-key");
exports.SIGMA_MODEL_TYPE_SLICE_KEY = slice_key_1.SliceKey.SigmaModelType;
exports.ELEMENT_SIGMA_MODEL_TYPE_SLICE_KEY = slice_key_1.SliceKey.ElementSigmaModelType;
exports.PARAMETERS_SLICE_KEY = slice_key_1.SliceKey.Parameters;
exports.ELEMENT_PARAMETERS_SLICE_KEY = slice_key_1.SliceKey.ElementParameters;
var SliceMaskPolicy;
(function (SliceMaskPolicy) {
    SliceMaskPolicy["None"] = "none";
    SliceMaskPolicy["ModelType"] = "model_type";
    SliceMaskPolicy["ElementType"] = "element_type";
})(SliceMaskPolicy || (exports.SliceMaskPolicy = SliceMaskPolicy = {}));
function firstSigmaSubModel(payload) {
    return payload.spiceModels?.find(sigma_engine_shared_1.SPICE.isSubModelSigmaSubModel);
}
function readElementSigmaModelType(payload) {
    return firstSigmaSubModel(payload)?.modelId ?? '';
}
//# sourceMappingURL=slice-contracts.js.map